module.exports = __webpack_public_path__ + "static/media/FI.03e4dad3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/FI.svg
// module id = 250
// module chunks = 0